import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import BaseRoute from './sub-routes/base-route';
import PostRoute from './sub-routes/post-route';
import * as routes from '../../constants/routes';

const Forum = () => {
  return (
    <main className="forum">
      <Switch>
        <Route
          exact path={routes.forum}
          component={BaseRoute}
        />

        <Route
          exact path={routes.forum + routes.forum_routes.view_post + '/:postId'}
          component={PostRoute}
        />

        <Route path="*">
          <Redirect to={routes.forum} />
        </Route>
      </Switch>
    </main>
  );
};

export default Forum;
